export function questionWithServerCorrection(question, grading) {
  const correction = (grading?.correction || []).find(
    (item) => Number(item?.question_id) === Number(question?.db_id ?? question?.id)
  );
  if (!correction) return question;

  const correctIds = new Set(
    (correction.correct_choice_ids || []).map((id) => Number(id))
  );
  const choices = (question.choices || []).map((choice) => ({
    ...choice,
    is_correct: correctIds.has(Number(choice.id)),
  }));
  const reponsesCorrectes = choices.flatMap((choice, index) =>
    choice.is_correct ? [index] : []
  );

  return {
    ...question,
    choices,
    reponse_correcte: reponsesCorrectes[0],
    reponses_correctes: reponsesCorrectes,
    explication: correction.explanation || null,
  };
}

export function hasEmbeddedAnswerKey(question) {
  if (Array.isArray(question?.reponses_correctes) && question.reponses_correctes.length) {
    return true;
  }
  if (Number.isInteger(question?.reponse_correcte)) return true;
  return Array.isArray(question?.choices) &&
    question.choices.some((choice) => choice?.is_correct === true);
}

export function canGradeLocally(questions) {
  return Array.isArray(questions) &&
    questions.length > 0 &&
    questions.every(hasEmbeddedAnswerKey);
}
